import { defineMessages } from 'react-intl';

export const ganttChartMessages = defineMessages({
  emptyState: {
    defaultMessage: 'No data has been provided.',
    id: 'k+MFecbA4aJKNSbM',
    description: 'Empty state message for the gantt chart.',
  },
  errorState: {
    defaultMessage: 'An error occurred.',
    id: 'Pyb778wli2buPWzS',
    description: 'Error state message for the gantt chart.',
  },
});
